"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PfrRowOutlineColor = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var RadioListItem_1 = __importDefault(require("../radio-list-item/RadioListItem"));
var PfrRowOutlineColor;
(function (PfrRowOutlineColor) {
    PfrRowOutlineColor["success"] = "success";
    PfrRowOutlineColor["error"] = "error";
})(PfrRowOutlineColor = exports.PfrRowOutlineColor || (exports.PfrRowOutlineColor = {}));
/**
 * @component RadioListItemGroup
 *
 * @example
 * <RadioListItemGroup
 *    data={listData}
 *    name="customTerm"
 *    direction="column"
 *    formik={formik}
 *  />
 *
 * @param {listItemData[]} data array of list item data
 * @param {string} name name of the field
 * @param {string} direction one of 'row' | 'column'
 * @param {any} formik the Formik object that this is a part of
 * @param {boolean} disableShading if the rows should be shaded or not
 */
var RadioListItemGroup = function (props) {
    var data = props.data, name = props.name, _a = props.direction, direction = _a === void 0 ? 'column' : _a, formik = props.formik, disableShading = props.disableShading;
    return (react_1.default.createElement(material_1.Grid, { container: true, direction: direction, className: "pr-1" }, data.map(function (radio) { return (react_1.default.createElement(material_1.Grid, { key: radio.id, className: "radio-list-item" },
        react_1.default.createElement(RadioListItem_1.default, { id: radio.id, name: name, radioLabel: radio.label, value: JSON.stringify({
                value: radio.value,
                label: radio.label,
                secondaryLabel: radio.secondaryLabel,
                tertiaryLabel: radio.tertiaryLabel,
                endOfRowLabel: radio.endOfRowLabel,
                color: radio.selectColor
            }), checked: JSON.stringify({
                value: radio.value,
                label: radio.label,
                secondaryLabel: radio.secondaryLabel,
                tertiaryLabel: radio.tertiaryLabel,
                endOfRowLabel: radio.endOfRowLabel,
                color: radio.selectColor
            }) === formik.values[name], onChange: formik.handleChange, secondaryLabel: radio.secondaryLabel, tertiaryLabel: radio.tertiaryLabel, endOfRowLabel: radio.endOfRowLabel, isShaded: !disableShading, selectColor: radio.selectColor }))); })));
};
exports.default = RadioListItemGroup;
